import { useCallback } from 'react';

import {
  useLoyaltyGetWalmartPartnerCodeByLoyaltyIdLazyQuery,
  useLoyaltyServiceWalmartPartnerCodeLazyQuery,
} from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export function useWalmartPartnerCode(loyaltyId: string | undefined) {
  const enableServicePartners = Boolean(useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_SERVICE_PARTNERS));

  const [legacyQuery] = useLoyaltyGetWalmartPartnerCodeByLoyaltyIdLazyQuery({
    variables: { loyaltyId: loyaltyId ?? '' },
  });

  const [serviceQuery] = useLoyaltyServiceWalmartPartnerCodeLazyQuery();

  const getPartnerCode = useCallback(async (): Promise<string | undefined> => {
    if (enableServicePartners) {
      const result = await serviceQuery();
      return result.data?.loyaltyServiceWalmartPartnerCode?.code;
    }
    const result = await legacyQuery();
    return result.data?.loyaltyGetWalmartPartnerCodeByLoyaltyId?.code;
  }, [enableServicePartners, legacyQuery, serviceQuery]);

  return { getPartnerCode };
}
